export default __webpack_public_path__ + "static/media/new.2a9f4d0a.png";